import * as React from 'react';
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

interface CustomizedSnackbarsProps {
  open: boolean;
  severity: 'success' | 'warning' | 'error';
  message: string;
  onClose: () => void;
}

export default function CustomizedSnackbars(props: CustomizedSnackbarsProps): JSX.Element {
  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }

    props.onClose(); // Trigger the onClose from parent
  };

  return (
    <Snackbar
      open={props.open}
      autoHideDuration={5000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}      
    >
      <Alert
        onClose={handleClose}
        severity={props.severity}
        variant="filled"
        sx={{ width: '100%' }}
      >
        {props.message}
      </Alert>
    </Snackbar>
  );
}
